var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 12C2.6865 12 0 9.3135 0 6C0 2.6865 2.6865 0 6 0C9.3135 0 12 2.6865 12 6C12 9.3135 9.3135 12 6 12ZM8.3535 6.6465C8.2555 6.5485 8.1275 6.5 7.9995 6.5H6.5V3C6.5 2.724 6.2765 2.5 6 2.5C5.7235 2.5 5.5 2.724 5.5 3V6.5H4.0005C3.8725 6.5 3.7445 6.5485 3.6465 6.6465C3.451 6.842 3.451 7.158 3.6465 7.3535L5.6465 9.3535C5.744 9.451 5.872 9.5 6 9.5C6.128 9.5 6.256 9.451 6.3535 9.3535L8.3535 7.3535C8.549 7.158 8.549 6.842 8.3535 6.6465Z",
    fill: "#FD7557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDown);
export default __webpack_public_path__ + "static/media/price_down.48b68125f865fcd889ac0f297f7948f3.svg";
export { ForwardRef as ReactComponent };